/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Link } from "react-router-dom";
import { FlexContainer } from "@nordcloud/gnui";
import { TableExpanderTemplate } from "~/components/Tables/Columns/Expander";
import { ROUTES } from "~/routing/routes";
import { trimText } from "~/tools";
import { Row, SpendTreeItem } from "./types";

type Data = {
  row: Row;
  data: SpendTreeItem[];
};

const MAX_NAME_CHARS = 50;

export const OrganizationUnitChildTableColumns = (structureId: string) => {
  return [
    {
      Header: "Organizational Unit Name",
      accessor: "name",
      disableSortBy: true,
      Cell: ({ row }: Data) => {
        return (
          <FlexContainer>
            <TableExpanderTemplate raw row={row} />
            <FlexContainer
              direction="column"
              alignItems="flex-start"
              css={{
                flex: 1,
              }}
            >
              <Link
                to={`${ROUTES.businessContexts.index}/${structureId}/${row?.original?.nid}`}
              >
                {trimText(row.original.name, MAX_NAME_CHARS)}
              </Link>
            </FlexContainer>
          </FlexContainer>
        );
      },
    },
  ];
};
